import { FC } from 'react';
import { Heading, VStack } from '@chakra-ui/react';
import {
  Achievement,
  AchievementStatistics,
  Card,
  Loader,
} from '../../../components';
import { useAchievements } from '../../../hooks';

export const Achievements: FC = () => {
  const {
    data: { achievements, totalAchievements, totalUnlockedAchievements },
    isInitialLoading,
  } = useAchievements();

  return (
    <Card mb={6}>
      <Heading size="md" color="brand.primary.swatch1">
        Achievements
      </Heading>

      <VStack mt={4} spacing={4} w="full">
        {isInitialLoading && <Loader />}
        <AchievementStatistics
          unlockedCount={totalUnlockedAchievements}
          totalAchievements={totalAchievements}
        />

        <VStack spacing={4} w="full">
          {achievements.map((a, i) => (
            <Achievement
              description={a.description}
              icon={a.icon}
              title={a.title}
              key={`${a.title}_${i}`}
              href={a.href}
              onClick={a.onClick}
              actionTitle={a.actionTitle}
              isComplete={a.value}
              isLoading={a?.isLoading}
            />
          ))}
        </VStack>
      </VStack>
    </Card>
  );
};
